// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1T960","footer":"ModalError_footer__3LHkd"};